import { useEffect } from 'react';
import { Link } from 'react-router-dom';

const LegalNotice = () => {
  const whatsappNumber = '34667459830';
  const whatsappMessage = encodeURIComponent('Hola, me gustaría obtener más información sobre sus armarios a medida.');

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-black">
      {/* Navigation */}
      <nav className="bg-black/95 backdrop-blur-md border-b border-amber-500/20">
        <div className="max-w-7xl mx-auto px-6 flex items-center justify-between h-20">
          <Link to="/" className="flex items-center gap-2">
            <img src="https://static.readdy.ai/image/5ec0a551afa550ea327b68ffd2fc4f5a/5325238bb7e02f6b3dd25e9784834fa4.png" alt="Benno Armarios de Diseño" className="h-16 w-auto" />
          </Link>
          <Link to="/" className="px-6 py-2.5 text-base font-semibold transition-all duration-300 text-white hover:text-amber-400 whitespace-nowrap cursor-pointer">
            <i className="ri-arrow-left-line mr-2"></i>Volver al inicio
          </Link>
        </div>
      </nav>

      {/* Content */}
      <main className="py-16 px-6">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-8">Aviso Legal</h1>
          <div className="w-16 h-0.5 bg-gradient-to-r from-amber-500 to-amber-600 mb-12"></div>

          <div className="prose prose-invert max-w-none space-y-8 text-gray-400">
            <section>
              <h2 className="text-2xl font-bold text-white mb-4">1. Datos identificativos</h2>
              <p>
                En cumplimiento del artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y Comercio Electrónico (LSSI-CE), se informa al usuario de los datos del titular de este sitio web:
              </p>
              <ul className="list-none space-y-2 mt-4">
                <li><strong className="text-white">Denominación social:</strong> ÁLJURSON SL</li>
                <li><strong className="text-white">Nombre comercial:</strong> Armarios Benno</li>
                <li><strong className="text-white">CIF:</strong> [CIF de la empresa]</li>
                <li><strong className="text-white">Domicilio social:</strong> Calle Escayolistas 13, 28891 Velilla de San Antonio, Madrid</li>
                <li><strong className="text-white">Teléfono:</strong> 91 791 933</li>
                <li><strong className="text-white">Email:</strong> info@armariosbenno.com</li>
                <li><strong className="text-white">Inscrita en:</strong> Registro Mercantil de Madrid</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">2. Objeto</h2>
              <p>
                <strong className="text-amber-500">Armarios Benno</strong> es una empresa especializada en el diseño, fabricación e instalación de armarios a medida desde 1998. A través de este sitio web, proporcionamos información sobre nuestros productos y servicios, incluyendo armarios de corredera, abatibles, plegables, interiores personalizados y separación de ambientes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">3. Condiciones de uso</h2>
              <p>
                El acceso y uso de este sitio web atribuye la condición de usuario e implica la aceptación plena de todas las condiciones incluidas en este Aviso Legal. El usuario se compromete a hacer un uso adecuado de los contenidos y servicios que Armarios Benno ofrece.
              </p>
              <p className="mt-4">Queda expresamente prohibido:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Utilizar los contenidos con fines ilícitos o contrarios a lo establecido en este Aviso Legal</li>
                <li>Difundir contenidos que atenten contra los derechos de terceros</li>
                <li>Provocar daños en los sistemas físicos y lógicos de Armarios Benno o de terceros</li>
                <li>Introducir virus informáticos o cualquier otro sistema que pueda causar daños</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">4. Propiedad intelectual e industrial</h2>
              <p>
                Todos los contenidos de este sitio web, incluyendo textos, fotografías, gráficos, imágenes, iconos, tecnología, software, diseños, así como la marca <strong className="text-amber-500">Armarios Benno</strong> y sus logotipos, son propiedad de ÁLJURSON SL o de terceros que han autorizado su uso.
              </p>
              <p className="mt-4">
                Queda prohibida la reproducción, distribución, comunicación pública, transformación o cualquier otra actividad que se pueda realizar con los contenidos de esta web sin la autorización expresa de Armarios Benno.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">5. Exclusión de garantías y responsabilidad</h2>
              <p>
                Armarios Benno no se hace responsable de los daños y perjuicios de cualquier naturaleza que pudieran derivarse de:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>La falta de disponibilidad o continuidad del funcionamiento del sitio web</li>
                <li>La existencia de virus o programas maliciosos en los contenidos</li>
                <li>El uso ilícito, negligente o fraudulento del sitio web</li>
                <li>La falta de veracidad, exactitud o actualidad de los contenidos</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">6. Enlaces externos</h2>
              <p>
                Este sitio web puede contener enlaces a páginas de terceros. Armarios Benno no asume ninguna responsabilidad por el contenido, información o servicios que pudieran aparecer en dichos sitios, que tendrán exclusivamente carácter informativo.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">7. Modificaciones</h2>
              <p>
                Armarios Benno se reserva el derecho de efectuar sin previo aviso las modificaciones que considere oportunas en su sitio web, pudiendo cambiar, suprimir o añadir tanto los contenidos y servicios que se presten a través de la misma como la forma en la que estos aparezcan presentados.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">8. Legislación aplicable y jurisdicción</h2>
              <p>
                La relación entre Armarios Benno y el usuario se regirá por la normativa española vigente. Para la resolución de cualquier controversia, las partes se someterán a los Juzgados y Tribunales de Madrid, salvo que la ley aplicable disponga otra cosa.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-white mb-4">9. Contacto</h2>
              <p>
                Para cualquier consulta relacionada con este Aviso Legal, puedes contactarnos en:
              </p>
              <p className="mt-2">
                <strong className="text-amber-500">Email:</strong> info@armariosbenno.com<br />
                <strong className="text-amber-500">Teléfono:</strong> 91 791 933<br />
                <strong className="text-amber-500">Dirección:</strong> Calle Escayolistas 13, 28891 Velilla de San Antonio, Madrid
              </p>
            </section>

            <p className="text-sm text-gray-600 mt-12">Última actualización: Enero 2025</p>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-8 px-6 border-t border-amber-500/20 bg-black">
        <div className="max-w-7xl mx-auto text-center">
          <p className="text-xs text-gray-600">© 2025 Armarios Benno. Todos los derechos reservados.</p>
          <a className="text-xs text-gray-600 hover:text-amber-500 transition-colors cursor-pointer mt-2 inline-block" href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer">
            Realizado por grupo Globaltis
          </a>
        </div>
      </footer>

      {/* WhatsApp Floating Button */}
      <a
        href={`https://wa.me/${whatsappNumber}?text=${whatsappMessage}`}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-[#25D366] rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-300 cursor-pointer group"
        aria-label="Contactar por WhatsApp"
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
        <span className="absolute right-full mr-3 px-3 py-2 bg-white text-gray-800 text-sm font-medium rounded-lg shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-300 whitespace-nowrap pointer-events-none">
          ¿Te ayudamos?
        </span>
      </a>
    </div>
  );
};

export default LegalNotice;
